module.exports = __webpack_public_path__ + "static/media/2.2f3fb5da.jpg";